import { lazy } from "react";
import Icon from "../../components/Icon";

const Invoice = lazy(() => import("./Invoice"));
const Proforma = lazy(() => import("./Proforma"));
const PaymentDebt = lazy(() => import("./PaymentDebt"));
const ReturnInvoice = lazy(() => import("./ReturnInvoice"));
const Receipts = lazy(() => import("./Receipts"));
const TrustBalance = lazy(() => import("./TrustBalance"));
const Deposits = lazy(() => import("./Deposits"));
const Payments = lazy(() => import("./Payments"));
const PaymentError = lazy(() => import("./Payments/PaymentError"));
const PaymentSuccess = lazy(() => import("./Payments/PaymentSuccess"));
const Settlement = lazy(() => import("./Settlement"));
const PaymentDebtTestPasargad = lazy(() => import("./PaymentDebtTestPasargad"));

let FinancialRoutes = [
  {
    path: "/financial/invoice",
    exact: false,
    title: "فاکتورها",
    sidebar: true,
    iconTag: <Icon name={"factor"} className={"drawerIcons large"} />,
    component: Invoice,
    roles: ["LIMITED"],
  },
  {
    path: "/financial/proforma",
    exact: false,
    title: "پرداخت وجه",
    sidebar: true,
    iconTag: <Icon name={"factor"} className={"drawerIcons large"} />,
    component: Proforma,
    roles: ["GLOBAL"],
  },
  {
    path: "/financial/payment-debt",
    exact: false,
    title: "تسویه بدهی",
    sidebar: true,
    iconTag: <Icon name={"paid"} className={"drawerIcons large"} />,
    component: PaymentDebt,
    roles: ["GLOBAL"],
    // show: (balance?: number) => balance && balance < 0,
  },
  {
    path: "/financial/return-invoice",
    exact: false,
    title: "برگشت از فروش",
    sidebar: true,
    iconTag: <Icon name={"return-invoice"} className={"drawerIcons large"} />,
    component: ReturnInvoice,
    roles: ["LIMITED"],
  },
  {
    path: "/financial/receipts",
    exact: false,
    title: "رسیدهای دریافت وجه",
    sidebar: true,
    iconTag: <Icon name={"receipts"} className={"drawerIcons large"} />,
    component: Receipts,
    roles: ["LIMITED"],
  },
  {
    path: "/financial/trust-balance",
    exact: false,
    title: "وضعیت سپرده",
    sidebar: true,
    iconTag: <Icon name={"pay-chart"} className={"drawerIcons large"} />,
    component: TrustBalance,
    roles: ["LIMITED"],
  },
  {
    path: "/financial/deposits",
    exact: false,
    title: "فهرست ودیعه‌ها",
    sidebar: true,
    iconTag: <Icon name={"deposits-list"} className={"drawerIcons large"} />,
    component: Deposits,
    roles: ["LIMITED"],
  },
  {
    path: "/financial/payments",
    exact: false,
    component: Payments,
    roles: ["GLOBAL"],
  },
  {
    path: "/financial/settlement",
    exact: false,
    component: Settlement,
    roles: ["GLOBAL"],
  },
  {
    path: "/financial/payment/error",
    exact: false,
    component: PaymentError,
    roles: ["GLOBAL"],
  },
  {
    path: "/financial/payment/success",
    exact: false,
    component: PaymentSuccess,
    roles: ["GLOBAL"],
  },
  {
    path: "/financial/test/pasargad",
    exact: true,
    title: "تسویه بدهی تستی",
    sidebar: false,
    iconTag: <Icon name={"paid"} className={"drawerIcons large"} />,
    component: PaymentDebtTestPasargad,
    roles: ["GLOBAL"],
  },
];

export default FinancialRoutes;
